module.exports = __webpack_public_path__ + "static/media/sonicstop-1.3e6b8573.jpg";